import { createTheme } from "@mui/material/styles";

const darkPalette = {
  mode: "dark",
  background: { default: "#14191e", paper: "#1e2530" },
  primary: { main: "#dbdbdb" },
  text: { primary: "#dbdbdb", secondary: "#8a8f98" },
  divider: "#2a3040"
};

const lightPalette = {
  mode: "light",
  background: { default: "#dfe3eb", paper: "#ffffff" },
  primary: { main: "#2a3040" },
  text: { primary: "#1a1f26", secondary: "#5a6070" },
  divider: "#c8cdd6"
};

const typography = {
  fontFamily: '"Quicksand", sans-serif',
  h1: { fontSize: "3rem", fontWeight: 500 },
  h2: { fontSize: "2rem", fontWeight: 400 },
  h3: { fontSize: "1.5rem", fontWeight: 400 },
  h4: { fontSize: "1.25rem", fontWeight: 400 },
  h5: { fontSize: "1.125rem", fontWeight: 400 },
  h6: { fontSize: "1.0625rem", fontWeight: 400 },
  body1: { fontSize: "1rem", lineHeight: 1.6 },
  body2: { fontSize: "0.75rem", lineHeight: 1.6 }
};

export function createAppTheme(mode) {
  return createTheme({
    cssVariables: true,
    palette: mode === "light" ? lightPalette : darkPalette,
    typography
  });
}

const theme = createAppTheme("dark");
export default theme;
